import StatisticsLoginTable from './StatisticsTableContainer';

export default StatisticsLoginTable;
